<template>
  <v-card height="100%">
    <v-card-title class="headline primary lighten-3">
      bepaal uw apotheek
    </v-card-title>
    <v-card-text v-if="loadingSelectedPharmacy" class="pa-5">
      <v-progress-circular indeterminate v-if="true"></v-progress-circular>
    </v-card-text>
    <v-card-text v-else-if="!savedPharmacy" class="pa-5">
      We still don't know which pharmacy you are. Help us to find it!
    </v-card-text>
    <v-card-text v-else class="pa-5">
      Currently set to
      <span class="green--text font-italic font-weight-medium">{{
        savedPharmacy.title
      }}</span>
    </v-card-text>
    <v-card-text>
      <v-text-field
        id="autocomplete"
        v-model="autocomplete_text"
        placeholder="Enter your pharmacy address"
        single-line
        outlined
      ></v-text-field>
    </v-card-text>
    <v-divider></v-divider>
    <v-expand-transition>
      <v-list v-if="select" class="red lighten-3">
        <v-list-item v-for="(field, i) in fields" :key="i">
          <v-list-item-content>
            <v-list-item-title v-text="field.value"></v-list-item-title>
            <v-list-item-subtitle v-text="field.key"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-expand-transition>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="!selectedPharmacyId" @click="clearAutocomplete">
        Clear
      </v-btn>
      <v-btn
        :disabled="!selectedPharmacyId"
        color="primary"
        @click="savePharmacy"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import firebase from "firebase/app";
import data from "../services/data";

export default {
  data() {
    return {
      select: null,
      selectedPharmacyId: null,
      autocomplete: null,
      autocomplete_text: null,
      savedPharmacy: null,
      loadingSelectedPharmacy: true
    };
  },
  mounted() {
    let vueApp = this;
    let googleApiScript = document.createElement("script");
    googleApiScript.type = "text/javascript";
    googleApiScript.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDnWjDRSBk8LK8VzApwTmj-MRD0uz_6d8A&libraries=places&callback=initGoogleApi";
    document.querySelector("head").appendChild(googleApiScript);
    window.initGoogleApi = function() {
      let placeChanged = function() {
        vueApp.selectedPharmacyId = autocomplete.getPlace()?.place_id;
      };
      let google = window.google;
      let autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        { types: ["establishment"], fields: ["place_id", "name", "types"] }
      );
      vueApp.autocomplete = autocomplete;
      autocomplete.addListener("place_changed", placeChanged);
    };

    data
      .getUserActivationRequest(firebase.auth().currentUser.uid)
      .then(activationRequest => {
        if (activationRequest && activationRequest.pharmacy) {
          this.savedPharmacy = activationRequest.pharmacy;
          this.loadingSelectedPharmacy = false;
        }
      });
  },
  methods: {
    clearAutocomplete() {
      this.selectedPharmacyId = null;
      this.autocomplete.set("place", null);
      this.autocomplete_text = "";
    },
    savePharmacy() {
      this.loadingSelectedPharmacy = true;
      const user = firebase.auth().currentUser;
      data
        .setUserPharmacy(
          user.uid,
          user.email,
          this.selectedPharmacyId,
          this.autocomplete.getPlace().name
        )
        .then(() => {
          this.savedPharmacy = {
            id: this.selectedPharmacyId,
            title: this.autocomplete.getPlace().name
          };
          this.loadingSelectedPharmacy = false;
          this.clearAutocomplete();
        });
    }
  }
};
</script>
